import './styles.css';
import { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import "react-calendar/dist/Calendar.css";
import firebase from 'firebase/compat/app';

const fmt = (date) =>
  `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;

export default function CalendarComponent() {
  const [closedDays, setClosedDays] = useState([]);

  useEffect(() => {
    firebase.firestore().collection('calendar').doc('items').get()
      .then((doc) => {
        if (doc.exists && Array.isArray(doc.data().closedDays)) {
          setClosedDays(doc.data().closedDays);
        }
      });
  }, []);

  const getTileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    const isHoliday = closedDays.includes(fmt(date));
    return (
      <p style={isHoliday ? { color: 'white', backgroundColor: '#E0405C', fontSize: '8px', fontWeight: 'bold', borderRadius: '2px' } : {}}>
        {isHoliday ? '定休日' : <br />}
      </p>
    );
  };

  return (
    <div className='calendar'>
      <Calendar
        locale="ja-JP"
        calendarType="US"
        value={new Date()}
        tileContent={getTileContent}
      />
    </div>
  );
}
